import { BREAKPOINTS } from '../consts';

export function deviceWidth () {
  const windowInnerWidth = window.innerWidth;

  if (windowInnerWidth >= BREAKPOINTS.desktopXXL) {
    return 'DESKTOP_XXL';
  } else if (windowInnerWidth >= BREAKPOINTS.desktopMedium) {
    return 'DESKTOP_MEDIUM';
  } else if (windowInnerWidth >= BREAKPOINTS.desktop) {
    return 'DESKTOP';
  } else if (windowInnerWidth >= BREAKPOINTS.tablet) {
    return 'TABLET';
  } else {
    return 'PHONE'
  }
};